var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ModuleItem__container{background:no-repeat 0;cursor:pointer;margin-bottom:4px;padding-left:18px;position:relative;white-space:nowrap}.ModuleItem__container.ModuleItem__module{background-image:url(" + escape(require("../assets/icon-module.svg")) + ");background-position-x:1px}.ModuleItem__container.ModuleItem__folder{background-image:url(" + escape(require("../assets/icon-folder.svg")) + ")}.ModuleItem__container.ModuleItem__chunk{background-image:url(" + escape(require("../assets/icon-chunk.svg")) + ")}.ModuleItem__container.ModuleItem__invisible:hover:before{background:url(" + escape(require("../assets/icon-invisible.svg")) + ") no-repeat 0;content:\"\";height:100%;left:0;top:1px;position:absolute;width:13px}", ""]);

// exports
exports.locals = {
	"container": "ModuleItem__container",
	"module": "ModuleItem__module",
	"folder": "ModuleItem__folder",
	"chunk": "ModuleItem__chunk",
	"invisible": "ModuleItem__invisible"
};